<template>
    <v-dialog v-model="dialog" max-width="500" @click:outside="hide">
        <v-card>
            <v-card-title>
                {{ $t('admin.change_student_coach_title') }}
                <v-spacer></v-spacer>
                <v-icon @click="hide">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-3">
                    <v-col cols="12">
                        {{ $t('admin.change_student_coach_text') }} <span class="bolder">{{ studentName }}</span>
                    </v-col>
                    <v-col cols="12">
                        <kimsa-combobox
                            :placeholder="$tc('coach.coach', 2)"
                            outlined dense solo
                            :items="coachesFiltered"
                            @change="coach = $event"
                            :value="coach"
                            icon="$training"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click="hide" class="normal-btn">
                    {{ $t('common.cancel') }}
                </v-btn>
                <v-btn depressed color="primary" class="normal-btn black--text" :disabled="disabled"
                       @click="changeStudent" :loading="loading">
                    {{ $t('common.change') }}
                </v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import firebase, {db, FieldValue} from "@/utils/Firebase";
import {mapMutations, mapState} from "vuex";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";

export default {
    name: "StudentChangeCoachDialog",
    components: {KimsaCombobox},
    props: {
        coaches: {
            type: Array,
            default: null,
        },
        currentStudent: {
            type: Object,
            default: null,
        },
        currentCoach: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            coach: null,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        disabled(vm = this) {
            return !vm.coach
        },
        studentName(vm = this) {
            return vm.currentStudent?.name || vm.$t('common.not_available_short')
        },
        coachesFiltered(vm = this) {
            if (!vm.coaches) return []
            if (!vm.currentCoach) return []
            return vm.coaches.filter(coach => coach.id !== vm.currentCoach.id).map(coach => {
                return {
                    id: coach.id,
                    name: `${coach?.name || vm.$t('common.not_available_short')} - ${coach.email}`
                }
            })
        }
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.loading = false
            vm.coach = null
        },
        async changeStudent() {
            const vm = this
            vm.loading = true

            await db.collection('subscriptions').doc(vm.currentStudent.studentSubscription.id).delete()

            let subscription = await db.collection('subscriptions').add({
                studentId: vm.currentStudent.id,
                coachId: vm.currentCoach.id,
                paused: false,
                createdAt: FieldValue.serverTimestamp()
            })

            await db.collection('users').doc(vm.currentCoach.id).update({
                activeStudents: FieldValue.increment(-1)
            })

            await db.collection('users').doc(vm.coach.id).update({
                activeStudents: FieldValue.increment(1)
            })

            let payload = {
                studentSubscription: {
                    coachDescription: vm.coach?.description || '',
                    coachId: vm.coach.id,
                    coachName: vm.coach?.name || vm.$t('common.not_available_short'),
                    id: subscription.id
                }
            }

            if(vm.currentStudent?.group) {
                payload.group = null
                let currentGroup = await db.collection('groups').doc(vm.currentStudent.group).get()
                if (currentGroup.data()) {
                    let students = currentGroup.data().students.filter(st => st !== vm.currentStudent.id)
                    await db.collection('groups').doc(vm.currentStudent.group).update({students: students})
                }
            }
            if(vm.currentStudent?.team) {
                payload.team = null
                let currentTeamRef = await db.collection('teams').doc(vm.currentStudent.team.id).get()
                if (currentTeamRef.data()) {
                    let currentTeam = {id: currentTeamRef.id, ...currentTeamRef.data()}
                    let currentGroup = currentTeam?.groups?.find(group => vm.currentStudent.team.subgroupId === group.id)
                    let students = currentGroup.students.filter(st => st !== vm.currentStudent.id)
                    let groups = JSON.parse(JSON.stringify(currentTeam?.groups))
                    let findGroupIndex = currentTeam?.groups?.findIndex(group => group.id === vm.currentStudent.team.subgroupId || null)
                    groups[findGroupIndex].students = students
                    await db.collection('teams').doc(vm.currentStudent.team.id).update({groups: groups})
                }
            }

            await db.collection('users').doc(vm.currentStudent.id).update(payload)

            vm.loading = false
            vm.hide()
            vm.$emit('changed')
            vm.toast(vm.$t('admin.student_changed'))
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>

</style>